<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M22.3611 0H9.63892C4.31549 0 0 4.31549 0 9.63892V22.3611C0 27.6845 4.31549 32 9.63892 32H22.3611C27.6845 32 32 27.6845 32 22.3611V9.63892C32 4.31549 27.6845 0 22.3611 0Z"
    fill="#ECE0F5"
  />
  <path
    d="M26.5125 11.7759C26.5125 9.71641 24.8429 8.04688 22.7835 8.04688C20.724 8.04688 19.0544 9.71641 19.0544 11.7759C19.0544 13.8354 20.724 15.5049 22.7835 15.5049C24.8429 15.5049 26.5125 13.8354 26.5125 11.7759Z"
    fill="#E23393"
  />
  <path
    d="M6.69147 9.13951C7.39044 8.44054 8.33833 8.04769 9.32683 8.04731C10.3153 8.04693 11.2635 8.43904 11.963 9.13748L18.7064 15.8809C19.0529 16.2254 19.328 16.635 19.5159 17.0861C19.7038 17.5372 19.8009 18.0209 19.8015 18.5096C19.8022 18.9982 19.7064 19.4822 19.5198 19.9338C19.3331 20.3854 19.0591 20.7957 18.7136 21.1412L16.0635 23.7913L6.68637 14.4142C5.98704 13.7148 5.59417 12.7663 5.59417 11.7773C5.59417 10.7883 5.98704 9.83986 6.68637 9.14054L6.69147 9.13951Z"
    fill="#5A1CB7"
  />
</svg>
